(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.style = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var NOTIFY_CLASS = exports.NOTIFY_CLASS = 'klick-notify';
  var MESSAGE_CLASS = exports.MESSAGE_CLASS = 'klick-notify-message';
  var CLOSE_CLASS = exports.CLOSE_CLASS = 'klick-notify-close';
  var IS_VISIBLE_CLASS = exports.IS_VISIBLE_CLASS = 'is-visible';
  var CONTAINER_CLASS = exports.CONTAINER_CLASS = 'klick-notify-container';
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/klicknotify/lib/config/style.js
 ** module id = 144
 ** module chunks = 2
 **/